import React from 'react'
import Header from './Header'

export default function Error404() {
    return (
        <Header>
            <section>
                <div class="error-page mt-5">
                    <div class="container-fluid p-0">
                        <div class="error-img text-center pt-5">
                            <img src="../assets/img/error-404.gif" alt="error-404" width="30%" class="img-fluid" />

                        </div>
                    </div>
                </div>
            </section>

        </Header>
    )
}
